
//Firearm Type
export const FIREARM_TYPE_MODERATOR = "moderator";

//Firearm Pool Status
export const FIREARM_POOL_STATUS_ACTIVE = "A";
export const FIREARM_POOL_STATUS_CLOSED = "C";

export const BUSINESS_UNIT_EMAIL_CONTACT_POLICE = "PN";
export const BUSINESS_UNIT_EMAIL_CONTACT_OUTGOING_CORRESPONDENCE = "OC";

//Location Type
export const LOCATION_TYPE_FORESTRY = "F";
export const LOCATION_TYPE_GUN_DEALER = "G";
export const LOCATION_TYPE_POLICE = "P";
export const LOCATION_TYPES_EXETERNAL = [LOCATION_TYPE_GUN_DEALER, LOCATION_TYPE_POLICE];